<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Edit Barionet Device</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="device.name">
          </div>
          <div class="form-group">
            <label for="txtIp">IP</label>
            <input type="text" class="form-control" id="txtIp" v-model="device.ip">
          </div>
          <div class="form-group">
            <label for="txtPort">Port</label>
            <input type="text" class="form-control" id="txtPort" v-model="device.port">
          </div>
          <div class="form-group" v-for="device_attribute in filtered_device_attributes" :key="device_attribute.attr_name">
            <label :for="'txt' + device_attribute.attr_name">{{ device_attribute.attr_name }}</label>
            <input type="text" class="form-control" :id="'txt' + device_attribute.attr_name" v-model="device_attribute.attr_str">
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'AdminBarionetIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'device_id'
  ],
  computed: {
    ...mapGetters({
      device: 'singleDevice',
      machine_type: 'machineType'
    }),
    filtered_device_attributes: function () {
      return this.device.device_attributes.filter(da => this.machine_type === 'Cloud')
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getDevice', this.device_id)
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditDevice', { device: this.device, push_on_success: 'AdminBarionetIndex' })
    }
  }
}
</script>

<style scoped>

</style>
